<script setup lang="ts">
import type { PortableTextComponentProps } from '@portabletext/vue';

// See: https://sanity.nuxtjs.org/helpers/images#using-sanityimage-url

const props = defineProps<PortableTextComponentProps<{
  // Keys come in under props.value
  _key: string;
  _type: string;
}>>();
</script>

<template>
  <p>
    
  </p>
</template>
